export { default } from "./GoogleTagManagerScript";
